import {ChartSignalEntry} from '@models/pages/user-defined-page/chart-signal-entry';
import {Axis} from '@models/pages/interactive-data-analysis/interactive-data-analysis-signal-chart-properties';

export class ChartAxisSettings {
  id: string = '';
  axisYLabel: string = '';
  minY: number = 0;
  maxY: number = 0;
  position: Axis = Axis.LEFT;

  signals: ChartSignalEntry[] = [];
}
